import { createAsyncThunk } from '@reduxjs/toolkit'
import MetricPeriod from './metric-period-model'
import {
  delete_metricPeriod,
  load_metricPeriods,
  store_metricPeriod,
} from './metricPeriod-service'

export const LoadMetricPeriodsAsync = createAsyncThunk<any, any>(
  'composer/load/metricPeriod',
  async (params: { uid: string }) => {
    return await load_metricPeriods(params)
  },
)

export const CreateMetricPeriodAsync = createAsyncThunk<any, any>(
  'composer/create/metricPeriod',
  async (params: MetricPeriod) => {
    return await store_metricPeriod(params)
  },
)

export const DeleteMetricPeriodAsync = createAsyncThunk<any, any>(
  'composer/delete/metricPeriod',
  async (params) => {
    return await delete_metricPeriod(params)
  },
)
